import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-answers-element',
  templateUrl: './answers-element.component.html',
  styleUrls: ['./answers-element.component.css']
})
export class AnswersElementComponent implements OnInit {
@Input() answerElement: {answerText: string, answerLetter: string};
@Input() answerElementSubmittedAnswer='';
@Output() onSubmitAnswer = new EventEmitter<{finalAnswer: string}>();

  isSelected = false;

  constructor() {

    }

  ngOnInit() {
  }

  getAnswerColor() {
  return this.answerElement.answerText == this.answerElementSubmittedAnswer ? 'yellow' : 'gray';
  }

SubmitAnswer(answerText: string) {
  this.onSubmitAnswer.emit({finalAnswer: answerText});
}


}
